<div id="nav-top">
    <mat-icon>help_outline</mat-icon>
    <a (click)="logout()" data-cy="quick-nav-logout" class="mt-2"><mat-icon>lock_open</mat-icon></a>
</div>